import { render, staticRenderFns } from "./XunjiaMyDetail.vue?vue&type=template&id=0f55d79d&scoped=true"
import script from "./XunjiaMyDetail.vue?vue&type=script&lang=js"
export * from "./XunjiaMyDetail.vue?vue&type=script&lang=js"
import style0 from "./XunjiaMyDetail.vue?vue&type=style&index=0&id=0f55d79d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f55d79d",
  null
  
)

export default component.exports